import firebase from 'firebase'
const config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
    apiKey: "AIzaSyDt34K8eTOsxEqd-D6Dc4A9_yFXzJ4m98k",
    authDomain: "graphql-visp-net.firebaseapp.com",
    databaseURL: "https://graphql-visp-net.firebaseio.com",
    storageBucket: "graphql-visp-net.appspot.com",
    messagingSenderId: "926816226434"
};
const fire = firebase.initializeApp(config);
export default fire;